import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import ApiService from './api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import { User, Role, UserRightEnum } from '@pulpo/pulpo-models';

@Injectable({ providedIn: 'root' })
export class RoleService extends ApiService<Role> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/roles');
  }

  getUsers(roleId: number): Observable<HttpResponse<User[]>> {
    return this.http.get<any>(`${this.url}/${this.endpoint}/${roleId}/users`, {
      observe: 'response',
    });
  }

  hasPermissions(permissions: { name: string; right: UserRightEnum }[]) {
    console.debug('Checking permissions for ', permissions);
    return true;
  }
}
